import * as yup from 'yup';

import { ObjectTypeBase } from '../../baseTypes/ObjectTypeBase';
import { PropertiesInterface } from '../Property';
import { TypeContextEnum } from '../TypeContextEnum';
import { Types } from '../Types';
import { TYPE_GROUP_LANE } from '../constants';
import { createShapeFromProperties } from '../createShapeFromProperties';

const properties: PropertiesInterface = {
  _id: {
    type: 'UUID',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
};

export class SectionType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  name = 'Section';

  friendlyName = 'Section';

  contexts = [TypeContextEnum.Block];

  superUserOnly = false;
  properties = properties;

  get example() {
    return {
      _id: '03SA53cjUgmXIdZp9VOi7e',
    };
  }

  get default(): any {
    return {
      _id: null,
    };
  }

  buildSchema() {
    return yup
      .object()
      .nullable()
      .default(null)
      .shape(createShapeFromProperties(properties));
  }
}

const definition = new SectionType();

Types.addBaseType(definition);
export { definition as SectionDefinition };
